import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form,
      labelAlign: "left"
    }
  }, [_c("a-row", [this.accountInfo.tag != 0 ? _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("订单归属")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("订单归属"),
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption2
    },
    on: {
      change: _vm.customerChange
    },
    model: {
      value: _vm.form.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerId", $$v);
      },
      expression: "form.customerId"
    }
  }, _vm._l(_vm.customerList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "top",
        title: item.name
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1);
  }), 1)], 1)], 1) : _vm._e(), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("手机号")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("手机号"),
      allowClear: ""
    },
    model: {
      value: _vm.form.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.form, "mobile", $$v);
      },
      expression: "form.mobile"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("用户")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("用户"),
      allowClear: ""
    },
    model: {
      value: _vm.form.userName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "userName", $$v);
      },
      expression: "form.userName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("订单号")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("订单号"),
      allowClear: ""
    },
    model: {
      value: _vm.form.orderNo,
      callback: function ($$v) {
        _vm.$set(_vm.form, "orderNo", $$v);
      },
      expression: "form.orderNo"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("订单类型")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("订单类型"),
      allowClear: ""
    },
    model: {
      value: _vm.form.type,
      callback: function ($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("APP投保")))]), _c("a-select-option", {
    attrs: {
      value: 2
    }
  }, [_vm._v(_vm._s(_vm.$t("批量投保")))]), _c("a-select-option", {
    attrs: {
      value: 3
    }
  }, [_vm._v(_vm._s(_vm.$t("H5投保")))]), _c("a-select-option", {
    attrs: {
      value: 4
    }
  }, [_vm._v(_vm._s(_vm.$t("API投保")))]), _c("a-select-option", {
    attrs: {
      value: 5
    }
  }, [_vm._v(_vm._s(_vm.$t("线下业务")))])], 1)], 1)], 1), _vm.showItem ? _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("订单来源")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("订单来源"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption
    },
    on: {
      change: _vm.getInsuranceFun
    },
    model: {
      value: _vm.form.applicationId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "applicationId", $$v);
      },
      expression: "form.applicationId"
    }
  }, _vm._l(_vm.applicationList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.applicationId
      }
    }, [_vm._v(_vm._s(item.name) + "(" + _vm._s(item.type == 1 ? "app" : item.type == 2 ? "h5" : item.type == 3 ? "pc" : _vm.$t("小程序")) + ")")]);
  }), 1)], 1)], 1) : _vm._e(), _vm.showItem ? _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("产品名称")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请先选择订单来源"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption,
      disabled: _vm.form.applicationId ? false : true
    },
    model: {
      value: _vm.form.insuranceId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "insuranceId", $$v);
      },
      expression: "form.insuranceId"
    }
  }, _vm._l(_vm.productList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1) : _vm._e(), _vm.showItem ? _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("创建时间")
    }
  }, [_c("datePicker", {
    ref: "applicationTime",
    on: {
      change: _vm.onChangeTime
    }
  })], 1)], 1) : _vm._e(), _vm.accountInfo.tag !== 1 && _vm.showItem ? _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("承保机构")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("机构"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption2
    },
    model: {
      value: _vm.form.agencyId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "agencyId", $$v);
      },
      expression: "form.agencyId"
    }
  }, _vm._l(_vm.intermediaryList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "top",
        title: item.name
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1);
  }), 1)], 1)], 1) : _vm._e(), _vm.showItem ? _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("订单状态")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("订单状态"),
      allowClear: ""
    },
    model: {
      value: _vm.form.payStatus,
      callback: function ($$v) {
        _vm.$set(_vm.form, "payStatus", $$v);
      },
      expression: "form.payStatus"
    }
  }, _vm._l(_vm.PAYSTATUS, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(_vm._s(_vm.$t(item.value)))]);
  }), 1)], 1)], 1) : _vm._e(), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_vm.tagData.length != 0 ? _c("a-button", {
    attrs: {
      type: "linkSeach"
    },
    on: {
      click: function ($event) {
        _vm.tagShow = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("标签查询")))]) : _vm._e(), _c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        _vm.showItem = !_vm.showItem;
      }
    }
  }, [_vm._v(_vm._s(_vm.showItem ? _vm.$t("收起查询条件") : _vm.$t("更多查询条件")))])], 1)], 1), _vm.tagList.length != 0 ? _c("a-row", [_c("a-form-item", {
    staticClass: "tagBox",
    attrs: {
      label: _vm.$t("已选择标签")
    }
  }, [_c("tag-list", {
    attrs: {
      tagList: _vm.tagList,
      tagData: _vm.tagData,
      format: "second"
    },
    on: {
      ok: _vm.tagListOk
    }
  })], 1)], 1) : _vm._e(), _c("div", {
    staticClass: "marginT10"
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))]), _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "edit"
    },
    on: {
      click: _vm.resetFun
    }
  }, [_vm._v(_vm._s(_vm.$t("重置")))]), _vm.isAuth("customer.orderDownload") ? _c("a-button", {
    staticClass: "marginR15",
    on: {
      click: _vm.downloadFun
    }
  }, [_vm._v(_vm._s(_vm.$t("导出")))]) : _vm._e()], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "tag",
      fn: function (text, record) {
        return [_c("click-show-tag", {
          attrs: {
            data: record.tagsData
          }
        }, [_c("span", {
          attrs: {
            slot: "icon"
          },
          slot: "icon"
        }, [_c("a-icon", {
          attrs: {
            type: "switcher"
          }
        })], 1)])];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [_vm.isAuth("customer.orderDetail") ? _c("a-button", {
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "customerOrder",
                params: {
                  id: record.orderId
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("查看")))]) : _vm._e()];
      }
    }])
  }, [_vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), _c("template", {
    slot: "customTitle"
  }, [_vm._v(_vm._s(_vm.$t("操作")) + " "), _c("a-icon", {
    staticClass: "setting",
    attrs: {
      type: "setting"
    },
    on: {
      click: _vm.settingColumn
    }
  })], 1)], 2), _c("tag-model", {
    attrs: {
      dialogVisible: _vm.tagShow,
      tagData: _vm.tagData,
      tagList: _vm.tagList,
      format: "second"
    },
    on: {
      cancel: function ($event) {
        _vm.tagShow = false;
      },
      ok: _vm.tagOk
    }
  }), _c("selectShowColumn", {
    ref: "selectShowColumn",
    attrs: {
      page: "order"
    },
    on: {
      refreshList: _vm.searchFun
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };